

<h1 class="page-header">Subscrive to our Newsletter</h1>

<div class="col-xs-12" style="height:50px;"></div>

<section class="contact-info">
    <div class="container">
        <div class="row">
            <app-newsletter-subs-form [showTitle]="false"></app-newsletter-subs-form>
        </div>
    </div>
</section>

<div class="col-xs-12" style="height:100px;"></div>
